<template>
	<div class="favorite-tabs">
		<span class="favorite-tabs-icon" style="font-family:tahoma" @click="toggleList">F2</span>
		<!-- <icon :title="title" icon="bolt" class="favorite-tabs-icon" @click="toggleList" /> -->
		<div class="favorite-tabs-list-container" id="favoriteTabsContainer">
			<List v-show="listVisible" ref="list" tabindex="0" v-model="selectedTab" :data="tabs" :options="componentOptions.list" @enter-pressed="tabClicked" @update:modelValue="tabClicked" />
		</div>
	</div>
</template>

<script>
	import List from '~/components/general/nikan-list'
	import $sc from "~/plugins/shortcut.collection"
	import NikanAnimation from '~/plugins/anime'
	import { mapGetters } from 'vuex'
	import { routes } from '~/statics/routes'
	export default {
		name: 'favorite-tabs',
		emits: ['visibility-changed'],
		props: {
			currentTabId: {
				type: String
			},
			visible: {
				type: Boolean
			}
		},
		components: {
			List
		},
		created() {
			this.getSettings()
		},
		watch: {
			visible: {
				handler(val) {
					this.listVisible = val
				},
			}
		},
		mounted() {

			const addToList = (item) => {

				if (item.addToFavorites)
					this.favoriteTabs.push(item)

				if (item.items && item.items.length) {
					for (let i = 0; i < item.items.length; i++) {
						addToList(item.items[i])
					}
				}
			}

			if (this.settings.value.checkedTabs.length)
				this.favoriteTabs = this.settings.value.checkedTabs
			else
				for (let j = 0; j < routes.length; j++)
					addToList(routes[j])


			this.animeInstance = new NikanAnimation('#favoriteTabsContainer',
				{
					opacity: [0, 1],
					easing: 'linear',
					duration: 200,
				})

		},
		computed: {
			...mapGetters({
				getRecentTabs: 'tabHistory/getRecentTabs',
				getActiveState: 'appStates/getActiveByKey',

			}),
			tabs() {
				var res = [...this.favoriteTabs]
				var seprator = {
					seprator: true,
					html: `
						<div class="favorite-tabs-recent-tabs">
							<span class="favorite-tabs-recent-tabs-text">
								${this.$t('recent-tabs')}
							</span>
						</div>`
				}

				var recentTabs = this.getRecentTabs
				recentTabs = recentTabs.filter(x => x.id !== this.currentTabId && !x.sticky)
				var index = -1 * this.settings.value.maxHistories
				var slicedRecent = recentTabs.slice(index)

				if (slicedRecent.length) {
					res.push(seprator)
					res.push(...slicedRecent)
				}

				return res
			},
		},
		data() {
			return {
				listVisible: false,
				selectedTab: null,
				animeInstance: null,
				oldFocusedElement: null,
				title: `${this.$t('favorite-tabs')} (${this.shortcutDisplay()})`,
				componentOptions: {
					list: {
						multiSelection: false,
						display: (item) => `<i class="fas fa-${item.icon} ml-1"></i>  ${item.pageTitle}`
					}
				},
				favoriteTabs: [],
				settings: {
					value: {
						checkedTabs: [],
						maxHistories: 5
					}
				}
			}
		},
		methods: {
			shortcutDisplay() {
				var arr = []
				var sc = $sc.find('favorite-tabs')

				if (sc.keyCode > 0) {
					if (sc.ctrlKey === true) {
						arr.push('Ctrl')
					}
					if (sc.shiftKey === true) {
						arr.push('Shift')
					}
					if (sc.altKey === true) {
						arr.push('Alt')
					}

					var key = sc.keyCode
					var keyChar = String.fromKeyCode(key)
					keyChar = keyChar || ''

					arr.push(keyChar)
					return arr.join(' + ')
				} else {
					return ''
				}
			},
			tabClicked() {
				this.$openTab(this.selectedTab)
				this.listVisible = false
			},
			getSettings() {
				const settings = this.getActiveState('favoriteTabs')
				if (settings) {
					this.settings = settings
				}
			},
			toggleList() {
				this.animeInstance.play()
				this.listVisible = !this.listVisible
				this.$emit('visibility-changed', this.listVisible)

				this.defer(() => {
					const list = this.$refs.list.$el

					if (this.listVisible && document.activeElement !== list) {
						this.oldFocusedElement = document.activeElement
						list.focus()
					}
					else {
						this.oldFocusedElement.focus()
					}

				}, 1)
			}

		},
	}
</script>

<style lang="less">
	@import "~/styles/favorite-tabs.less";
</style>
